var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "nav-item dropdown d-none d-sm-block" }, [
    _c(
      "a",
      {
        staticClass: "nav-link",
        attrs: { role: "button" },
        on: { click: _vm.toggle_notification_list },
      },
      [
        _c("i", {
          staticClass: "icon md-notifications",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _vm.messages_error ? _c("span", [_vm._m(0)]) : _vm._e(),
        _vm._v(" "),
        !_vm.messages_error && _vm.messages_loading
          ? _c("span", [_vm._m(1)])
          : _vm._e(),
        _vm._v(" "),
        !_vm.messages_error && !_vm.messages_loading
          ? _c("span", [
              _vm.unread_messages.length
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill badge-danger up badge-notify-js",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.unread_messages.length) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "dropdown-menu dropdown-menu-right dropdown-menu-media dropdown-menu-notify",
        class: { show: _vm.show_notification_list },
        attrs: { role: "menu" },
      },
      [
        _c("div", { staticClass: "bell-notify" }, [
          _c("div", { staticClass: "bell-notify__heading" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("span", {
              staticClass: "badge badge-pill badge-danger mr-2 badge-notify-js",
            }),
            _vm._v(" "),
            _vm.unread_messages.length
              ? _c(
                  "div",
                  {
                    staticClass: "bell-notify__btn",
                    attrs: { id: "read_all" },
                  },
                  [
                    _vm.reading_all_error
                      ? _c("i", {
                          staticClass: "fa fa-exclamation-triangle",
                          attrs: {
                            "aria-hidden": "true",
                            "data-toggle": "tooltip",
                            "data-placement": "right",
                            "data-original-title": "Ошибка!",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.reading_all_error && _vm.reading_all_loading
                      ? _c("i", {
                          staticClass: "fa fa-spinner fa-pulse",
                          attrs: {
                            "aria-hidden": "true",
                            "data-toggle": "tooltip",
                            "data-placement": "right",
                            "data-original-title": "Загрузка...",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.reading_all_error && !_vm.reading_all_loading
                      ? _c("i", {
                          staticClass: "icon md-check-all",
                          attrs: {
                            id: "bellCheckAll",
                            "data-toggle": "tooltip",
                            "data-placement": "left",
                            "data-original-title":
                              "Отметить все сообщения прочитанными",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.readMessages()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bell-notify__tab", attrs: { id: "bellNotifyTab" } },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane active",
                    attrs: {
                      id: "notify-read",
                      role: "tabpanel",
                      "aria-labelledby": "notify-read-tab",
                    },
                  },
                  [
                    _vm.unread_messages.length
                      ? _c(
                          "span",
                          _vm._l(_vm.unread_messages, function (message) {
                            return _c("notification-bell-message", {
                              key: message.id,
                              attrs: { item: message },
                              on: { read: _vm.readMessages },
                            })
                          }),
                          1
                        )
                      : _c("div", { staticClass: "stack stack--notice" }, [
                          _c("span", [_vm._v("У вас нет новых уведомлений")]),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    attrs: {
                      id: "notify-unread",
                      role: "tabpanel",
                      "aria-labelledby": "notify-unread-tab",
                    },
                  },
                  [
                    _vm.read_messages.length
                      ? _c("span", [
                          _c(
                            "div",
                            {
                              staticClass: "bell-notify__item",
                              attrs: { role: "menuitem" },
                            },
                            _vm._l(_vm.read_messages, function (message) {
                              return _c("notification-bell-message", {
                                key: message.id,
                                attrs: { item: message },
                              })
                            }),
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "stack stack--notice" }, [
                          _c("span", [_vm._v("У вас нет новых уведомлений")]),
                        ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "badge badge-light up badge-notify-js" }, [
      _c("i", {
        staticClass: "fa fa-exclamation-triangle",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "badge badge-light up badge-notify-js" }, [
      _c("i", {
        staticClass: "fa fa-spinner fa-pulse",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bell-notify__title" }, [
      _c("h6", [_vm._v("УВЕДОМЛЕНИЯ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
      [
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link active",
              attrs: {
                id: "notify-read-tab",
                "data-toggle": "tab",
                href: "#notify-read",
                role: "tab",
                "aria-controls": "notify-read",
                "aria-selected": "true",
              },
            },
            [_vm._v("Новые")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: {
                id: "notify-unread-tab",
                href: "#notify-unread",
                "data-toggle": "tab",
                "aria-controls": "exampleTabsTwo",
                role: "tab",
              },
            },
            [
              _c("div", { staticClass: "d-flex justify-content-center" }, [
                _c("span", [_vm._v("Прочитанные")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "help-sign-mini qform-help pl-10",
                    attrs: {
                      "data-toggle": "tooltip",
                      id: "bellNotifyHelp",
                      rel: "tooltip",
                      title: "",
                      "data-original-title": "Сообщения хранятся 30 дней",
                    },
                  },
                  [_c("i", { staticClass: "md md-help-outline" })]
                ),
              ]),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }